import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuyBowComponent } from './buyBow.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [BuyBowComponent]
})
export class BuyBowModule { }
